export const RESET = 'EXCMDEVICEBRAND_UPDATE_RESET'
export const SET_ERROR = 'EXCMDEVICEBRAND_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMDEVICEBRAND_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMDEVICEBRAND_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMDEVICEBRAND_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMDEVICEBRAND_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMDEVICEBRAND_UPDATE_UPDATE_RETRIEVED'
